import React from "react";
import {
  retrievePayrollDetailsByFileId,
  getFundingTransactionDetailsOfEmployeeInPayrollSubmissionPage,
} from "../../services";
import { usDateFormat, ssnMasking, usCurrency } from "../../utils";
import { useRequest } from "../../abstracts";
import { isEmpty } from "lodash";
import AddToolTip from "../AddToolTip";
import { dataOverrideReport } from "../../containers/Payroll/PayrollReportsContainer/constant";

const PayrollPendingSubmission = ({ data, fileId, hideField }) => {
  const { response: payrollDataView, loading: isLoading } = useRequest({
    method: retrievePayrollDetailsByFileId,
    payload: fileId,
    defaultResponse: [],
  });

  const { response: payrollData, loading: isLoading1 } = useRequest({
    method: getFundingTransactionDetailsOfEmployeeInPayrollSubmissionPage,
    payload: { fileId: fileId, employeeId: data },
    defaultResponse: [],
  });

  return (
    <>
      {hideField === false &&
        !isEmpty(payrollData) &&
        payrollData.map((payrollData) => (
          <div
            className="payroll-pending-submission"
            style={{ border: "1px solid #D8D8DC", borderRadius: "8px" }}
          >
            {payrollData.employeePayrollTransactions.map((employee) => (
              <>
                <div className="p-3 mt-3 mb-3 mx-3 d-flex justify-content-between slider-pending-background payroll-detail-slider">
                  <div>
                    <p className="grey-text ft-14 mb-1">Pay date</p>
                    <p className="black-text ft-16 font-weight-500">
                      {usDateFormat(employee.payDate)}
                    </p>
                  </div>
                  <div>
                    <p className="grey-text ft-14 mb-1">Plan name</p>
                    <p className="black-text ft-16 font-weight-500">
                      {employee.planName.length >= 10 ? (
                        <AddToolTip name={employee.planName} placement="bottom">
                          <div className="column-planName">
                            {(employee.planName || "").slice(0, 10)}...
                          </div>
                        </AddToolTip>
                      ) : (
                        <div className="column-planName">
                          {employee.planName}
                        </div>
                      )}
                    </p>
                  </div>
                  <div>
                    <p className="grey-text ft-14 mb-1">Plan ID</p>
                    <p className="black-text ft-16 font-weight-500">
                      {employee.rkPlanNumber}
                    </p>
                  </div>
                </div>
                <div className="mx-3 payroll-file-table-view">
                  <div className="d-flex justify-content-between table-head">
                    <div className="ft-16" style={{ color: "#7C7C80" }}>
                      Payroll file Total
                    </div>
                    <div className="ft-16" style={{ color: "#7C7C80" }}>
                      Amount
                    </div>
                  </div>
                  <div className="table-body">
                    {employee.transactionSourceDetails.map((item, index) => (
                      <div
                        className="d-flex justify-content-between"
                        key={`source${index}`}
                      >
                        <div>{item.sourceName}</div>
                        <div className="fw-600">{usCurrency(item.amount)}</div>
                      </div>
                    ))}
                    {/* <div className="line-separator" /> */}
                    <div className="d-flex justify-content-between">
                      <div>Loan Repayments</div>
                      <div className="fw-600">
                        {usCurrency(employee.loanRepayments)}
                      </div>
                    </div>

                    <div className="line-separator" />
                    <div className="d-flex justify-content-between fw-600">
                      <div>Total</div>
                      <div>{usCurrency(employee.total)}</div>
                    </div>
                  </div>
                </div>
              </>
            ))}
          </div>
        ))}
      {hideField === true &&
        !isEmpty(payrollDataView) &&
        payrollDataView.map((data) =>
          data.payrollTransactions.map((transaction) => (
            <div
              className="payroll-pending-submission"
              style={{ border: "1px solid #D8D8DC", borderRadius: "8px" }}
            >
              <div className="p-3 mt-3 mb-3 mx-3 d-flex justify-content-between slider-pending-background payroll-detail-slider">
                <div>
                  <p className="grey-text ft-14 mb-1">Pay date</p>
                  <p className="black-text ft-16 font-weight-500">
                    {usDateFormat(transaction.payDate)}
                  </p>
                </div>
                <div>
                  <p className="grey-text ft-14 mb-1">Plan name</p>
                  <p className="black-text ft-16 font-weight-500">
                    {data.planName.length >= 10 ? (
                      <AddToolTip name={data.planName} placement="bottom">
                        <div className="column-planName">
                          {(data.planName || "").slice(0, 10)}...
                        </div>
                      </AddToolTip>
                    ) : (
                      <div className="column-planName">{data.planName}</div>
                    )}
                  </p>
                </div>
                <div>
                  <p className="grey-text ft-14 mb-1">Total Records</p>
                  <p className="black-text ft-16 font-weight-500">
                    {transaction.totalRecords}
                  </p>
                </div>
              </div>
              <div className="mx-3 payroll-file-table-view">
                <div className="d-flex justify-content-between table-head">
                  <div className="ft-16" style={{ color: "#7C7C80" }}>
                    Payroll file Total
                  </div>
                  <div className="ft-16" style={{ color: "#7C7C80" }}>
                    Amount
                  </div>
                </div>
                <div className="table-body">
                  {transaction.transactionSourceDetails.map((item, index) => (
                    <div
                      className="d-flex justify-content-between"
                      key={`source${index}`}
                    >
                      <div>{item.sourceName}</div>
                      <div className="fw-600">{usCurrency(item.amount)}</div>
                    </div>
                  ))}
                  <div className="d-flex justify-content-between">
                    <div>Loan Repayments</div>
                    <div className="fw-600">
                      {usCurrency(transaction.loanRepayments)}
                    </div>
                  </div>
                  <div className="line-separator" />
                  <div className="d-flex justify-content-between fw-600">
                    <div>Total</div>
                    <div>{usCurrency(transaction.total)}</div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
    </>
  );
};

export default PayrollPendingSubmission;
